export default __webpack_public_path__ + "static/media/24.cf754882.webp";